import Vue from "vue";
import { resolveRequestError } from "@/utils/auth";
import * as ENDPOINTS from "./endpoints";
import secret from "@/utils/secret"
import CryptoJS from 'crypto-js'

export default class AuthService {

    // Login User
    static async login({ email, password }) {
        try {
            const { data } = await Vue.http.post(ENDPOINTS.LOGIN, {
                email,
                password,
            });
            try {
                const secretKey = '6909c787f7df839fac72355c3175e0bd0d95bbd994c8b989e5aff9b76619f791';
                const bytes = CryptoJS.AES.decrypt(data.data.user.data, secretKey,data.data.user.div);
                const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
               const user =  JSON.parse(decryptedData);
               data.data.user = user;
            } catch (error) {
                console.log(error);
            }
            if (data?.data?.user?.secrets) {
                localStorage.setItem("secret", data.data.user.secrets);
            }
            return data;
        } catch (err) {
            resolveRequestError(err);                                                                                                                                               
        }
    }

    // Register Device 
    static async savePushNotificationToken(token){
        const { data } = await Vue.http.post(ENDPOINTS.PUSHNOTIFICATIONTOKEN,token);
        return data;
    }

    // Recover Account 
    static async recover({ email }){
        try{
            const { data } = await Vue.http.post(ENDPOINTS.RECOVER,{
                email
            });
            return data;
        } catch (err) {
            resolveRequestError(err)
        }
    }

    // Reset Password
    static async reset ({ email, otp, password, cpassword}) {
        try{
            const { data } = await Vue.http.put(ENDPOINTS.RESET, {
                email,
                otp,
                password,
                cpassword
            });
            return data;
        }
        catch(err){
            resolveRequestError(err)
        }
    }

    // Generate 2FA Secret
    static async generate2FA(){
        try{
            const { data } = await Vue.http.post(ENDPOINTS.GENERATE_2FA);
            return data;
        }
        catch(err){
            resolveRequestError(err)
        }
    }

    // Validate 2FA Token
    static async verify2FA({ token }){
        try{
            const { data } = await Vue.http.post(ENDPOINTS.VERIFY_2FA, {
                token,
            },
        );
            try {
                const secretKey = '6909c787f7df839fac72355c3175e0bd0d95bbd994c8b989e5aff9b76619f791';
                const bytes = CryptoJS.AES.decrypt(data.data.user.data, secretKey,data.data.user.div);
                const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
                const user =  JSON.parse(decryptedData);
                data.data.user = user;
            } catch (error) {
                console.log(error);
            }
            return data
        }
        catch(err){
            resolveRequestError(err)
        }
    }

    // Authenticate User
    static authenticateUser(token) {
        Vue.http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        sessionStorage.setItem("authToken", token);
        const encryptedText = Vue.CryptoJS.AES.encrypt("true", secret).toString();
        sessionStorage.setItem("access", encryptedText)
      }
}